import { render, staticRenderFns } from "./VegaWithNarrative.vue?vue&type=template&id=6e22b912&scoped=true&"
import script from "./VegaWithNarrative.vue?vue&type=script&lang=js&"
export * from "./VegaWithNarrative.vue?vue&type=script&lang=js&"
import style0 from "./VegaWithNarrative.vue?vue&type=style&index=0&id=6e22b912&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e22b912",
  null
  
)

export default component.exports